/**
 * Format a date with moment
 */

import * as moment from 'moment';

export default (Vue) => {
	Vue.filter('inv-date', (value, format) => {
		return invDate(value, format);
	});

	Vue.prototype.$invDate = (value, format) => {
		return invDate(value, format);
	};

	/**
	 * Format a date with moment.
	 *
	 * @param {mixed} value
	 * @param {string} format
	 *
	 * @usage {{ date | inv-date }}
	 *    '2017-10-01 00:00:00' => '10/01/2017'
	 */
	function invDate(value, format = 'MM/DD/YYYY') {
		try {
			return moment(value).format(format);
		} catch (e) {
			console.warn(`[Invizon] warn: Either invalid value (${value}) or invalid format (${format})`);
			return value;
		}
	}
};